import React from "react";
import { StyleSheet, View, ViewProps } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export interface BaseHeaderMobileProps extends Omit<ViewProps, "style"> {
  leading?: React.ReactNode;
  middle?: React.ReactNode;
  trailing?: React.ReactNode;
  style?: ViewProps["style"];
}

function BaseHeaderMobile({
  leading,
  middle,
  trailing,
  style,
  ...props
}: BaseHeaderMobileProps) {
  const insets = useSafeAreaInsets();

  return (
    <View
      style={[
        styles.container,
        { paddingTop: insets.top + 8 }, // Reduced from 16 to 8 to fix iPhone gap
        style,
      ]}
      {...props}
    >
      <View style={styles.leftSection}>{leading}</View>
      <View style={styles.centerSection}>{middle}</View>
      <View style={styles.rightSection}>{trailing}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    minHeight: 64,
    paddingHorizontal: 16,
  },
  leftSection: {
    alignItems: "flex-start",
    justifyContent: "center",
  },
  centerSection: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    position: "relative", // Allow absolute positioning of children (e.g., logo)
  },
  rightSection: {
    alignItems: "flex-end",
    justifyContent: "center",
  },
});

export default React.memo(BaseHeaderMobile);

